import * as React from 'react'
import { connect } from 'react-redux'
import Modal from '../../common/modal'
import LineInput from '../../common/lineinput'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import LineInputV2 from '../../common/lineinputV2'
import DropDownOA from '../../common/dropDownOA'
import { useState } from 'react'
import { cancelBookingByAdmin, updateAlertError } from '../../../store/common/common_action'

const BookingCancelByAdminUI = (props) => {
  const { lrInfo, lrBookingInfo, userList, updateAlertError, handleConfirmPop, handleCancelBooking, data } = { ...props }
  const { common } = data
  let { loginData, } = { ...common }
  const [selUser, setSelUser] = useState('')
  const [cancelRemark, setCancelRemark] = useState('')
  const validPaymentTypes = ["PAID", "PAID(Manual)", "SELF", "TO_PAY_DDDV", "ToPayDDDV"];
  return (
    <Modal headTxt={`Booking Cancel`} width={'40%'} updateModal={() => { props.updateModal() }}>
      <Stack direction="column" sx={{ padding: '15px' }}>
        <div style={{ width: '100%', position: 'relative' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }} ref={props?.inputRef}>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={'LR Number'} value={lrInfo?.LRNo} disabled />
              </div>
            </Box>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={'Source Branch'} value={lrInfo?.BookingBranchName} disabled />
              </div>
            </Box>
            <Box sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px' }} >
              <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                <LineInputV2 id={'LR_Number'} type={`text`} name={'LR Number'} label={'Booked By User'} value={lrBookingInfo?.TransactionByUser} disabled />
              </div>
            </Box>
            <Box
              sx={{ width: '48.5%', display: 'inline-flex', padding: '0% 0px', }}>
              <DropDownOA
                id={`cancelByUserBtn`}
                label={`${selUser ? '' : 'Select'} Cancel By User`}
                data={userList?.filter((val) => val?.BranchID === lrInfo?.BookingBranchID && val?.IsActive !== 0)}
                dataKey={`UserName`}
                idKey={`UserID`}
                onSelect={(obj) => setSelUser(obj)}
                onReset={() => setSelUser('')}
                width='100%'
              />
            </Box>
            <div id='remark' style={{ width: '100%' }} className={'input--wrapper'}>
              <LineInput type={`text`} name={`vlmtrc_unit_wt`} label={`Cancel Remark`} onChange={(e) => { setCancelRemark(e.target.value) }} />
            </div>
            <div style={{ width: '100%', textAlign: 'center', fontWeight: '600' }}>
              <span>REFUND AMOUNT : {validPaymentTypes.includes(lrInfo.PaymentType) ? lrInfo.NetAmount : 0}</span>
            </div>
          </div>
        </div>
        <Box sx={{ width: '100%', margin: '12px 0px' }}>
          <Button variant="contained" id="saveVolumetricvol" className="btn btn-primary" sx={{ width: '100%', padding: '10px', letterSpacing: '2px' }}
            onClick={() => {
              if (loginData?.intCompanyID !== 406) {
                handleCancelBooking({ data: { selUser, validPaymentTypes, cancelRemark, lrInfo } })
              } else {
                if (selUser == '' || selUser == ' ') {
                  updateAlertError({ show: true, msg: 'Select Cancel By User', nextId: 'cancelByUserBtn' })
                } else if (cancelRemark === '') {
                  updateAlertError({ show: true, msg: 'Select Remark', nextId: 'remark' })
                } else {
                  handleConfirmPop({ data: { selUser, validPaymentTypes, cancelRemark, lrInfo } })
                }
              }
            }}
          >Cancel Booking</Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { cancelBookingByAdmin, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(BookingCancelByAdminUI)
